
import { Search } from "lucide-react";
import { useState } from "react";
import TypingPlaceholder from "./TypingPlaceholder";

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar = ({ onSearch }: SearchBarProps) => {
  const [inputValue, setInputValue] = useState("");
  const searchPhrases = [
    "Want to Rent a Vacation Home...",
    "Need a Car Mechanic Near Me...",
    "Searching for a Mobile App Developer...",
    "Seeking an Interior Designer...",
    "Looking for a Housekeeper...",
    "Hiring a Web Developer – Bonus $500 for Quick Completion!",
    "Need a Babysitter...",
    "Looking for a Social Media Manager...",
    "Want to Buy Handmade Jewelry...",
    "Seeking a Dog Walker...",
    "Looking for a Yoga Instructor...",
    "Searching for a Home Renovation Expert...",
    "Seeking a Professional Resume Writer...",
    "Want to Hire a Virtual Assistant...",
    "Need a Music Producer...",
    "Want a Personal Trainer – Earn a Free Gym Membership!",
    "Looking for a Graphic Designer...",
    "Need a Therapist Specializing in Anxiety...",
    "Seeking a Spanish Tutor...",
    "Looking for Affordable Wedding Venues...",
    "Searching for a Local Tour Guide...",
    "Want to Sell My Old Bike...",
    "Need a Private Investigator...",
    "Hiring a Babysitter – Bonus if You Can Teach a Second Language!",
    "Looking for a Custom Suit Tailor...",
    "Seeking a Wedding Photographer – Free Stay at Our Resort!",
    "Searching for Local Farmers Market Deals...",
    "Want to Learn Guitar...",
    "Looking for a Ghostwriter – Royalty Share Available!",
    "Seeking a Math Tutor – Free Coffee for Every Session!",
    "Looking for a Personal Stylist...",
    "Need a Reliable Plumber...",
    "Searching for a Business Consultant...",
    "Want to Learn Digital Marketing...",
    "Need a Dog Walker – Extra $100 if You Have Pet Training Experience!",
    "Want to Adopt a Cat...",
    "Looking for a Coding Bootcamp...",
    "Seeking a Speech Therapist...",
    "Looking for Python Developer...",
    "Looking for a Language Exchange Partner...",
    "Looking for a Used Car...",
    "Searching for a Rare Book...",
    "Looking for a Graphic Designer – Chance to Feature on a Billboard!",
    "Seeking a Social Media Manager – Profit Sharing on Growth!",
    "Need a Wedding Photographer...",
    "Need a Math Tutor...",
    "Want a Music Instructor – Free Concert Tickets Included!"
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    onSearch(value);
  };

  return (
    <div className="glass w-full max-w-2xl mx-auto p-2 rounded-full mb-8">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
        <input
          type="text"
          placeholder=" "
          value={inputValue}
          className="w-full pl-10 pr-4 py-2 rounded-full bg-transparent outline-none"
          onChange={handleInputChange}
        />
        {inputValue.length === 0 && (
          <div className="absolute left-10 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <TypingPlaceholder phrases={searchPhrases} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
